import { useEffect } from 'react';

import { useAppDispatch } from '../redux/hooks';
import { updateSharedTrackAssessmentSummary } from '../redux/sharedSession/sharedSession';
import { useGetMostRecentTrackAssessmentSummaryQuery } from '../redux/sharedSession/sharedSession.api';

type UseSharedTrackAssessmentDataProps = Readonly<{
  accessToken: string;
  skip?: boolean;
}>;

export const useSharedTrackAssessmentData = ({
  accessToken,
  skip = false,
}: UseSharedTrackAssessmentDataProps) => {
  const dispatch = useAppDispatch();

  const { data: trackAssessmentSummary } = useGetMostRecentTrackAssessmentSummaryQuery(
    { accessToken },
    { skip: !accessToken || skip },
  );

  useEffect(() => {
    if (trackAssessmentSummary) {
      dispatch(updateSharedTrackAssessmentSummary(trackAssessmentSummary));
    }
  }, [trackAssessmentSummary, dispatch]);

  return {
    trackAssessmentSummary,
  };
};
